<template>
  <div>
    <button class="d-none d-lg-inline-block noti-icon header-item-custom" :class="{ organization: layout ? layout === 'organization' : '' }" @click="show = true">
      <div class="file-manager-progress-button" :class="{ organization: layout ? layout === 'organization' : '' }">
        <i class="bx bxs-folder-open folder-icon" :class="{ organization: layout ? layout === 'organization' : '' }"></i>
      </div>
    </button>
    <div>
      <b-modal
        v-show="show"
        id="file-manager-widget"
        hide-footer
        centered
        :title="$t('file-manager.text')"
        scrollable
        size="lg"
        title-class="font-18"
        v-model="show"
        @hidden="onHide"
      >
        <div>
          <file-manager-progress show-progress="Download" />
        </div>

        <file-upload :scope="currentProduct" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import FileManagerProgress from "@c/form/file-manager-progress";
import FileUpload from "../../modules/file-manager/file-upload.vue";
export default {
  props: ["id", "title", "layout"],
  components: {
    FileManagerProgress,
    FileUpload,
  },
  computed: {
    uploadedFiles() {
      return this.$store.getters[`fileManager/uploadedFiles`];
    },
    downloadedFiles() {
      return this.$store.getters[`fileManager/downloadedFiles`];
    },
    isShow() {
      if (!this.uploadedFiles || !this.downloadedFiles) {
        return false;
      }

      return this.uploadedFiles.length + this.downloadedFiles.length > 0;
    },
    progressCount() {
      return this.uploadedFiles.filter((i) => i.progress != 100).length + this.downloadedFiles.filter((i) => i.progress != 100).length;
    },
    isDownloading() {
      return this.$store.getters[`fileManager/isDownloading`];
    },
    isUploading() {
      return this.$store.getters[`fileManager/isUploading`];
    },
  },
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnload);
  },

  watch: {
    downloadedFiles: {
      handler(v) {
        if (!v) {
          return;
        }

        v.forEach((item) => {
          if (item.status === "pending") {
            this.$store.dispatch("fileManager/download", item);
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onHide() {
      this.$emit("onHide");
    },
    beforeUnload(e) {
      if (!this.isUploading && !this.isDownloading) {
        return undefined;
      }
      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },
  },
};
</script>
<style scoped lang="scss">
.file-manager-progress-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.875rem;
  height: 2.875rem;
  border-radius: 0.625rem;
  border: 1px solid #d0d0d0;
  position: relative;
  transition: background-color, color, 0.3s;
  &.organization {
    background-color: #282a2e;
    background-color: #282a2e;
    border: 1px solid #363d52;
  }

  &:hover {
    background-color: white;
    background-color: white;
  }

  .folder-icon {
    color: #ff7c48;

    &.organization {
      border-color: #282a2e;
      transition: background-color, color, 0.3s;
    }
  }
}
.header-item-custom {
  height: 110px;
  box-shadow: none !important;
  background-color: #f4f6f8;
  border: 0;
  border-radius: 0px;

  &.organization {
    background-color: #272a2e;
    background-color: #272a2e;
  }

  &:hover {
    // background-color: white;
    // background-color: white;
  }
}
</style>
